// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2ace1554","703":"f8539855","787":"627470b2"}[chunkId] + ".chunk.js";
};